var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEqIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 49.865,
    height: 50.15,
    viewBox: "0 0 49.865 50.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_5962",
    x: 0,
    y: 0,
    width: 49.865,
    height: 49.865,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "EQ_icon",
    "data-name": "EQ icon",
    transform: "translate(-1.364 1.192)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5961",
    "data-name": "Path 5961",
    d: "M43.482,21.9A21.741,21.741,0,1,0,17.313,43.188l4.428,6.929,4.428-6.929A21.748,21.748,0,0,0,43.482,21.9",
    transform: "translate(4.556 -1.158)",
    fill: "#004f9f"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1.36, -1.19)",
    filter: "url(#Path_5962)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5962-2",
    "data-name": "Path 5962",
    d: "M44.236,28.462A15.933,15.933,0,1,1,28.3,12.529,15.933,15.933,0,0,1,44.236,28.462",
    transform: "translate(-3.37 -6.53)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("text", {
    id: "EQ",
    transform: "translate(12.916 11.071)",
    fill: "#004f9f",
    fontSize: 16,
    fontFamily: "Inter",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1,
    y: 16
  }, "EQ")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEqIcon);
export default __webpack_public_path__ + "static/media/EQ_icon.971a011da3913b827dede392302815a0.svg";
export { ForwardRef as ReactComponent };